module.exports = __webpack_public_path__ + "static/media/edit.45b30f6a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/edit.svg
// module id = 752
// module chunks = 1